import { jsx as _jsx } from "nativewind/jsx-runtime";
import { isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useCameraDevices } from 'react-native-vision-camera';
import * as S from './CameraDeviceSelect.style';
export default function CameraDeviceSelect({ device, onDeviceSelect }) {
    const devices = useCameraDevices();
    const [availableDevices, setAvailableDevices] = useState([]);
    // 기기의 카메라 중 어떤 카메라를 초기 카메라로 선택할지 결정
    useEffect(() => {
        const backCams = devices.filter(d => d.position === 'back');
        const multiCams = backCams.filter(d => d.isMultiCam);
        // 멀티캠이 없지만 후면 카메라가 있으면 후면 카메라를 선택할 수 있게 한다.
        if (!isEmpty(backCams) && isEmpty(multiCams)) {
            setAvailableDevices(backCams);
        }
    }, [devices]);
    // 멀티카메라 지원 : 카메라 선택 기능 필요 없음
    if (availableDevices.length === 0) {
        return null;
    }
    return (_jsx(S.DeviceTypes, { children: availableDevices.length > 1 &&
            availableDevices.map(d => (_jsx(S.DeviceTypeButton, { elementName: "camera_device_type_button", selected: d === device, onPress: () => onDeviceSelect(d), children: _jsx(S.DeviceTypeText, { selected: d === device, children: getDeviceTypeName(d) }) }, d.id))) }));
}
const getDeviceTypeName = (d) => {
    if (isEmpty(d.physicalDevices)) {
        return '';
    }
    switch (d.physicalDevices[0]) {
        case 'ultra-wide-angle-camera':
            return 'UW';
        case 'wide-angle-camera':
            return 'W';
        case 'telephoto-camera':
            return 'TP';
    }
};
